'use client'

import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Transition } from '@headlessui/react'
import clsx from 'clsx'
import { Fragment } from 'react'
import { RxCaretDown } from 'react-icons/rx'

import { cn } from '../../../utils'
import { TimeScale } from '../../types/Dashboard/types'

interface TimeScaleSelectorProps {
  timeScale?: TimeScale
  setTimeScale?: (timeScale: TimeScale) => void
  timeScaleOptions?: TimeScale[]
  className?: string
  buttonClassName?: string
  optionStyles?: string
}

export const TimeScaleSelector = ({
  buttonClassName = '',
  className = '',
  optionStyles = '',
  setTimeScale,
  timeScale,
  timeScaleOptions,
}: TimeScaleSelectorProps) => {
  if (!timeScale || !setTimeScale || !timeScaleOptions) return null

  return (
    <div className={cn('ml-auto z-10', className)}>
      <Listbox value={timeScale} onChange={setTimeScale}>
        <div className={cn('relative')}>
          <ListboxButton
            className={cn(
              'outline-none flex gap-1 justify-between items-center text-sm w-16 h-6 z-10 px-2 py-1 bg-black/70 border border-white/10 rounded data-[headlessui-state=open]:rounded-b-none',
              buttonClassName,
            )}
            data-testid="select-button"
          >
            {timeScale}
            <RxCaretDown width={8} height={8} className="-me-0.5" />
          </ListboxButton>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-150"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <ListboxOptions
              as="ul"
              className={clsx(
                'absolute right-0 z-10 flex w-full min-w-fit flex-col rounded-lg border border-white/10 bg-black text-gray-200 outline-none data-[headlessui-state=open]:rounded-t-none data-[headlessui-state=open]:border-t-0',
              )}
            >
              {timeScaleOptions.map(option => (
                <ListboxOption as="li" key={String(option)} value={option}>
                  {({ active, selected }) => (
                    <div
                      className={clsx(
                        'flex w-full min-w-fit cursor-pointer text-start justify-start whitespace-nowrap px-2 py-0.5 text-sm z-10',
                        optionStyles,
                        active || selected ? 'text-cblue-400' : '',
                      )}
                    >
                      {option}
                    </div>
                  )}
                </ListboxOption>
              ))}
            </ListboxOptions>
          </Transition>
        </div>
      </Listbox>
    </div>
  )
}
